<!--客户购买体验卡-->
<template>
  <div class="deduction">
    <el-form ref="registerRef" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="卡ID:">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="childInfo.id"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号:">
            <el-input
            v-model="childInfo.userPhone"
              readonly="true"
              style="width: 270px"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="childInfo.childName"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="卡名称:">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="childInfo.cardNameCopy"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="金额:">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="childInfo.totalPay"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="剩余课时:">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="childInfo.remainingClassDes"
              placeholder=""
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="等级:" prop="userPhone">
              <el-select placeholder="请选择" style="width: 270px">
                <el-option
                  v-for="item in [
                    { label: '一级', value: 1 },
                    { label: '二级', value: 2 },
                    { label: '三级', value: 3 },
                    { label: '四级', value: 4 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="当前有效期:" prop="userPhone">
            <el-date-picker
              style="width: 270px"
              v-model="childInfo.times"
              type="daterange"
              range-separator="~"
              start-placeholder="开始"
              end-placeholder="结束"
              value-format="yyyy-MM-dd"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12"> </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="扣课项目:" prop="cardName">
            <el-input  v-model="childInfo.cardName" style="width: 270px" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扣课课时:">
            <el-input style="width: 270px" placeholder="" v-model="childInfo.deductNum"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注:">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入内容"
          style="width: 740px"
          v-model="childInfo.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleUpdate()">确认</el-button>
    </div>
    <worker-word ref="workerWord" :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<script>
import commonUtils from "../../../utils/commonUtils";
import globaldata from "@/utils/globaldata";
import {
  deductCourse
} from "@/api/userByCard";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
export default {
  props: {
    childInfo:Object
  },
  components: {
    WorkerWord,
  },
  data() {
    return {
      refreshWord: new Date().getTime(),
      tData: {
        adminWord: ''
      },
      wordType: 0,
      showWordDlg: false,
      rules: {},

      param: {
        expCardPay: 0,
      },
      showWordDlg: false,
      refreshWord: "",
      wordType: "",

      genderOptions: [
        {
          value: "0",
          label: "男",
        },
        {
          value: "1",
          label: "女",
        },
      ],
      // childInfo: {},
    };
  },
  mounted() {},
  created() {},
  methods: {
    handleWord(wordType, tData) {
      let param = {
        cardName:this.childInfo.cardName,
        deductNum:this.childInfo.deductNum,
        userId:this.childInfo.userId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminWord:tData.adminWord,
        remark:this.childInfo.remark,
        cardId:this.childInfo.id
      }
      deductCourse(param).then((res)=>{
            if(res.code == 20000){
              this.$emit("handleUpdate");
            }
      })
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleUpdate() {
      this.$refs['workerWord'].showDlog = true
      // let param = {
      //   id: this.childId,
      //   name: this.param.name,
      //   petName: this.param.petName,
      //   birthday: this.param.birthday,
      //   gender: this.param.gender,
      // };

      // updateChildInfo(param).then((response) => {
      //   let data = response.data;
      //   if (commonUtils.isObjectNull(data)) {
      //     return;
      //   }
      //   if (data == true) {
      //     messageUtils.successMsg(this, response.message);
      //     this.$emit("handleUpdate");
      //   } else {
      //     messageUtils.errorMsg(this, response.message);
      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.deduction {
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff !important;
    color: #000 !important;
    background-color: #ffffff !important;
  }
  /deep/ .el-form {
    .el-row {
      .el-col {
        .el-form-item {
          .el-form-item__content {
            .el-date-editor {
                background: #ffffff !important;
                background-color: #ffffff !important;
              .el-range-input {
                background: #ffffff !important;
                color: #000 !important;
                background-color: #ffffff !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/DeductionOfClasses.vue